import Vue from 'vue'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
const dictionary = {
  ru: {
    messages: {
      required: () => 'Поле обязательно для заполнения',
      email: () => 'Проверьте правильность ввода емейла',
      min: (field, number) => {
        let suffix = ' символа';
        if (number == 1) {
          suffix = ' символ'
        } else if (number < 5) {
          suffix = ' символа';
        } else {
          suffix = ' символов';
        }
        return 'Минимум ' + number + suffix;
      },
      max: (field, number) => {
  
        let suffix = ' символа';
        if (number == 1) {
          suffix = ' символ'
        } else if (number < 5) {
          suffix = ' символа';
        } else {
          suffix = ' символов';
        }
        return 'Максимум ' + number + suffix;
      },
      confirmed: () => 'Пароли не совпадают',
    }
  }
};

// Override and merge the dictionaries
Validator.localize(dictionary);

const config = {
  locale: 'ru'
};

Vue.use(VeeValidate, config);

// import Vueditor from 'vueditor'
// // import CourseTest from 'wysiwyg-modules/courseTest'
//
// let plugins = [
//   {
//     name: 'course-test',
//     element: {
//       type: 'button',
//       lang: {
//         title: 'Course Test'
//       },
//       className: 'icon-smile-o'
//     },
//     // component: CourseTest
//   }
// ];
//
// // your config here
// let config = {
//   toolbar: [
//     'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor'
//   ],
//   fontName: [
//     {val: 'arial black'},
//     {val: 'times new roman'},
//     {val: 'Courier New'}
//   ],
//   fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
//   uploadUrl: '',
//   // plugins: plugins
// };
//
// Vue.use(Vueditor, config);